import { HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

export type BadgeTone =
  | "success"
  | "warn"
  | "danger"
  | "info"
  | "yellow"
  | "navy"
  | "ghost"
  | "violet"
  | "pink"
  | "indigo"
  | "sky";

type Props = HTMLAttributes<HTMLSpanElement> & {
  tone?: BadgeTone;
  children: ReactNode;
};

export function Badge({ tone = "ghost", className, children, ...rest }: Props) {
  return (
    <span className={clsx("tcg-badge", `tcg-badge-${tone}`, className)} {...rest}>
      {children}
    </span>
  );
}
